/**
 * The reactions a story can receive, mirroring src/Service/StoryReactions.php.
 *
 * Keys travel to the server, emoji stay here: the same key can be given a
 * different glyph later without touching stored rows. Kept in this order so the
 * strip reads the same everywhere, with the heart first because that is what
 * the old like became.
 */
export const REACTIONS = [
  { key: 'heart', emoji: '❤️' },
  { key: 'sweet', emoji: '🥰' },
  { key: 'wow', emoji: '😍' },
  { key: 'clap', emoji: '👏' },
  { key: 'haha', emoji: '😂' },
];

/** The emoji for a stored key, or the heart when the key is unknown. */
export function emojiFor(key) {
  const found = REACTIONS.find((r) => r.key === key);

  return found ? found.emoji : REACTIONS[0].emoji;
}
